import React, { Component } from 'react';
import {
  LoginErrorText,
  LoginFormTitle,
  LoginInputField,
  LoginInputLabel,
  StyledLoginForm,
  LoginLink
} from '../style-guide/Login';
import { Button } from './CommonUiComponents';

export default class LoginForgot extends Component {
  state = {
    username: '',
    emailSent: false
  };

  handleForgot = async e => {
    const { forgot } = this.props;
    const { username } = this.state;

    e.preventDefault();

    const response = await forgot(username, window.location.href);
    if (response.res.status === 200) {
      this.setState({
        emailSent: true
      });
    }
  };

  handleInputValue = e => {
    const { name, value } = e.target;

    this.setState({
      [name]: value
    });
  };

  render() {
    const { invertedTheme, loggingIn, loginError } = this.props;
    const { emailSent } = this.state;

    return (
      <StyledLoginForm onSubmit={this.handleForgot} method="POST">
        {!emailSent ? (
          <div>
            <LoginFormTitle inverted={invertedTheme}>
              Glemt passord
            </LoginFormTitle>
            <LoginInputLabel htmlFor={'username'} inverted={invertedTheme}>
              E-post
            </LoginInputLabel>
            <LoginInputField
              type="email"
              name="username"
              id="username"
              onChange={this.handleInputValue}
              disabled={loggingIn}
              inverted={invertedTheme}
              required
            />
            {loginError && (
              <LoginErrorText inverted={invertedTheme}>
                Ingen brukernavn med denne e-posten.
              </LoginErrorText>
            )}
            <Button type="submit" disabled={loggingIn}>
              {loggingIn ? 'Sender e-post...' : 'Send e-post'}
            </Button>
          </div>
        ) : (
          <LoginFormTitle inverted={invertedTheme}>
            E-post er sendt. Følg linken i e-posten for å resette passordet.
          </LoginFormTitle>
        )}
        <LoginLink to="..">Tilbake til innlogging</LoginLink>
      </StyledLoginForm>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginForgot.js